<template>
  <div class="container">
    <div class="key">
      <div class="key__item">
        <div class="key__colour"></div>
        <span class="key__name">Selected</span>
      </div>
      <div class="key__item">
        <div class="key__colour part-of-role"></div>
        <span class="key__name">Part Of Role</span>
      </div>
      <div class="key__item">
        <div class="key__colour conflicting"></div>
        <span class="key__name">Conflicting</span>
      </div>
      <div class="key__item">
        <div class="key__colour unavailable"></div>
        <span class="key__name">Unavailable</span>
      </div>
    </div>

    <div class="control-bar">
      <button id="btn-ok" @click="close">OK</button>
      <button id="btn-clear" @click="clear">Clear</button>
    </div>
  </div>  
</template>

<script>
export default {
  props: {
    positionNumber: Number,
  },

  methods: {
    close() {
      this.$emit("update:show-pi-modal", false);
    },

    clear() {
      this.$store.commit("clearCustomInstructions", 'player'+this.positionNumber);
    }
  }
}
</script>

<style scoped>
  .container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
  }

  .key__item {
    display: inline-block;
    margin: 0 4px;
  }

  .key__colour {
    width: 16px;
    height: 16px;
    margin-right: 4px;
    border-radius: 50%;
    background: #03A93C;
    display: inline-block;
  }

  .part-of-role {
    background: #89DB2C;
  }

  .conflicting {
    background: #F65E4F;
  }

  .unavailable {
    background: #FE4F4D;
  }

  button {
    margin: 4px;
    padding: 6px 16px;
    color: #fff;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: 0.3s;
  }

  button:hover {
    filter: brightness(1.2);
  }

  #btn-ok {
    background: #226CB8;
  }

  #btn-clear {
    background: #232C34;
  }
</style>
